import { icons } from "@patient-watch/icons";
import { commonComponents as cc } from "@/components/common";
import { diaryFootPhotosUploadMessagePath } from "@/features/diaries/routes";
import { useImagesStore } from "@/features/foot-watch/hooks/useImagesStore";
import UploadImageGallery from "@/features/foot-watch/photos/UploadGallery";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { shallow } from "zustand/shallow";

const AddPhotos = () => {
    const { diaryId, trackerId, entryId, pageIndex } = Route.useParams();
    const navigate = useNavigate();

    const [images] = useImagesStore((state) => [state.images, state.updateImages], shallow);

    return (
        <>
            <cc.Title words="Add Photos" />
            <UploadImageGallery
                imageTL={images.LT.base64}
                imageTR={images.RT.base64}
                imageBL={images.LS.base64}
                imageBR={images.RS.base64}
            />
            <cc.FooterButtons
                func1={() =>
                    navigate({
                        to: diaryFootPhotosUploadMessagePath,
                        params: { diaryId, trackerId, entryId, pageIndex },
                    })
                }
                words1="Next"
                icon1={
                    <div className="flex justify-center items-center ml-[2px] p-[6px] w-8 h-8 rotate-180">
                        <icons.BackArrow fill="white" />
                    </div>
                }
            />
        </>
    );
};
export const Route = createFileRoute(
    "/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/foot-photos/add-photos"
)({
    component: AddPhotos,
});
